import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import moment from "moment";
import { Col, Row, List, Spin, Modal, notification as Notification, Empty } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { errorMessageNotification, isMobile } from "../../../../helpers";

const { confirm } = Modal;

const type = "pendingvendortrips";
let searchTimeout = null;

class TripUnitApprovalList extends Component {

    constructor(props) {
        super(props);
        this.endpoint = { keyOne: type };
        this.state = {
            isResponsive: false,
            dataActives: [],
            totalActives: 0,
            loadings: {
                data: false
            },
            hasMore: true
        };
        this.filter = {
            page: 1,
            pagesize: 90,
            query: "",
            sort: "departureDate-desc"
        }
    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        this.getData();
        this.props.dispatch(actions.auth.getAccount());

    }

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint,
            filter: this.filter
        })).then(response => {
            loadings.data = false;

            this.setState({
                dataActives: response.data,
                totalActives: response.total,
                loadings
            });


        })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });
            })
    }

    onChangeSearchbox = (e) => {

        this.filter.query = e.target.value;

        if (e.target.value.length > 2) {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                this.getData(true);
            }, 500);
        } else {
            this.getData(true);
        }


    }

    onChangeSort = (value) => {
        this.filter.sortdirection = value;
        this.getData(true);
    }

    onDeleteConfirm = (id) => {

        let _this = this;
        let endpoint = { keyOne: `${type}`, idOne: id };

        confirm({
            centered: true,
            title: 'Adres Silme',
            icon: <ExclamationCircleOutlined />,
            content: 'Bu işlem bir daha geri alınamaz.',
            okText: "Sil",
            okType: "danger",
            onOk() {
                _this.props
                    .dispatch(
                        actions.definitions["deleteData"]({
                            ...endpoint,
                        })
                    )
                    .then((response) => {
                        _this.getData()
                        Notification.success({
                            message: errorMessageNotification(response),
                            className: "general-notification",
                            placement: "bottomLeft",
                            duration: 3,
                        });
                    }

                    );
            },
            onCancel() {
            },
        });

    }

    render() {

        let { loadings, dataActives, totalActives } = this.state;

        return (

            <Fragment>
                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <div className='list-container trips'>

                        {
                            dataActives.length > 0 &&

                            <div className='page-header'>
                                <Row>
                                    <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                                        <h1>
                                            <span className='count background-yellow'>{totalActives}</span>
                                            <span className='label'>Yönetici onayı bekleyen talep bulunuyor</span>
                                        </h1>
                                    </Col>
                                </Row>
                            </div>

                        }

                        <List
                            className='content-list'
                            grid={{
                                gutter: 16,
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3,
                                xxl: 3,
                            }}
                            locale={{
                                emptyText: <Empty
                                    image={Empty.PRESENTED_IMAGE_DEFAULT}
                                    imageStyle={{
                                        height: 60,
                                    }}
                                    description={
                                        <span>
                                            Onay bekleyen seyahat bulunmuyor!
                                        </span>
                                    }
                                >
                                </Empty>
                            }}
                            dataSource={dataActives}
                            renderItem={(item) => (

                                <List.Item
                                >
                                    {

                                        <div className='item-detail item-detail-yellow'
                                            onClick={() => this.props.history.push(`/app/trips/${item.id}`)}
                                        >

                                            <p className='date'>
                                                {moment(item.departureDate).format('DD MMMM YYYY')}

                                            </p>
                                            <p className='day'>
                                                {moment(item.departureDate).format('dddd')}

                                            </p>
                                            <p className='date'>
                                                {moment(item.departureDate).format('LT')}
                                            </p>
                                            <p className='subject mt-20'>
                                                Durumu
                                            </p>
                                            <p className='description'>
                                                {item.statusText}
                                            </p>
                                            <p className='subject'>
                                                Talep Sahibi
                                            </p>
                                            <p className='description'>
                                                {item.ownerNameLastname}
                                            </p>
                                            <p className='subject'>
                                                Transfer Tipi
                                            </p>
                                            <p className='description' style={{ minHeight: 32 }}>
                                                {item.transferTypeName}
                                            </p>
                                            <p className='subject'>
                                                Talep No
                                            </p>
                                            <p className='description'>
                                                #{item.id}
                                            </p>

                                        </div>

                                    }
                                </List.Item>
                            )}
                        />

                    </div>
                }
            </Fragment >

        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripUnitApprovalList);


// WEBPACK FOOTER //
// ./src/components/App/Views/TripUnitApproval/TripUnitApprovalList.js